import * as React from 'react';
export const menuSvg = React.forwardRef(function menuSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.5 3.125c0-.483.392-.875.875-.875h13.25a.875.875 0 0 1 0 1.75H1.375A.875.875 0 0 1 .5 3.125Zm0 4.876c0-.483.392-.875.875-.875h13.25a.875.875 0 0 1 0 1.75H1.375A.875.875 0 0 1 .5 8.001Zm0 4.874c0-.483.392-.875.875-.875h13.25a.875.875 0 0 1 0 1.75H1.375a.875.875 0 0 1-.875-.875Z',
    }),
  );
});
menuSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var menu = {
  category: 'icon',
  colorable: true,
  name: 'menu',
  svg: menuSvg,
};
